document.addEventListener('algolia.hooks.initialize', function () {
  const priceThreshold = 15000;

  // window.shopifyMarketCountry !== 'GB' && window.shopifyMarketCountry !== 'IE' && window.shopifyMarketCountry !== 'JE' if active
  if (false) {
    const style = document.createElement('style');
    style.innerHTML = `
      @media (max-width: 991px) {
        .aa-Label svg { color: white !important; }
        .aa-DetachedSearchButtonIcon { color: white !important; }
        .aa-Form { background-color: #000453 !important; border: white !important; }
        #autocomplete-0-label { background: transparent; }
        #autocomplete-0-input {
          background: transparent;
          border-color: transparent;
          color: white;
        }
        .aa-DetachedFormContainer { background: #000453; }
        .aa-DetachedCancelButton { display: none; }
        .aa-DetachedContainer { background-color: transparent !important; }
        .aa-DetachedContainer .aa-Panel { background-color: transparent !important; }
        .predictive-container_wrapper.custom-predictive-dropdown {
          width: 100% !important;
          border: none;
          position: fixed;
          top: 72px;
          z-index: 10000000000000;
        }
        .predictive-container_list-link {color: white;}
    `;
    document.head.appendChild(style);

    algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', () => '');
    algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', () => '');
    algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', () => '');
    algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', () => '');

    const observer = new MutationObserver((mutations, obs) => {
      const input = document.querySelector('.aa-DetachedContainer input.aa-Input');
      if (input) {
        obs.disconnect();

        let debounceTimeout;
        input.setAttribute('autocomplete', 'off');

        function removeDropdown() {
          const old = document.querySelector('.custom-predictive-dropdown');
          if (old) old.remove();
        }

        function escapeHtml(text) {
          return text.replace(/&/g, '&amp;')
                     .replace(/</g, '&lt;')
                     .replace(/>/g, '&gt;')
                     .replace(/"/g, '&quot;')
                     .replace(/'/g, '&#039;');
        }

        function renderDropdown(query, data) {
          removeDropdown();
          if (!query) return;

          const container = document.createElement('div');
          container.className = 'custom-predictive-dropdown predictive-container_wrapper';
          container.style.background = '#000453';
          container.style.border = 'none';
          container.style.width = '100%';
          container.style.zIndex = '100000000';
          container.style.display = 'flex';
          container.style.flexDirection = 'column';
          container.style.alignItems = 'stretch';
          container.style.top = '72px';
          container.style.position = 'fixed';

          // Prevent Algolia from closing on interaction inside our dropdown
          container.addEventListener('mousedown', e => e.stopPropagation());
          container.addEventListener('touchstart', e => e.stopPropagation());


          if (data.resources?.results?.products?.length) {
            const productsCol = document.createElement('div');
            productsCol.className = 'predictive-container_inner-col predictive-container_inner-col--products --word-break';

            const ul = document.createElement('ul');
            ul.className = 'list-unstyled predictive-container_list';

            data.resources.results.products.forEach(product => {
              const li = document.createElement('li');
              li.className = 'predictive-container_list-item';

              const a = document.createElement('a');
              a.className = 'predictive-container_list-link --word-break';
              a.href = product.url || `/products/${product.handle}`;

              const title = product.title || '';
              const idx = title.toLowerCase().indexOf(query.toLowerCase());

              if (idx >= 0) {
                a.innerHTML =
                  escapeHtml(title.substring(0, idx)) +
                  `<mark>${escapeHtml(title.substring(idx, idx + query.length))}</mark>` +
                  escapeHtml(title.substring(idx + query.length));
              } else {
                a.textContent = title;
              }

              li.appendChild(a);
              ul.appendChild(li);
            });

            productsCol.appendChild(ul);
            container.appendChild(productsCol);
          }

          const btnWrapper = document.createElement('div');
          btnWrapper.className = 'predictive-container_btn-wrapper';
          btnWrapper.style.padding = '10px';
          btnWrapper.style.textAlign = 'center';

          const btn = document.createElement('button');
          btn.type = 'submit';
          btn.className = 'button button--primary predictive-container_btn';
          btn.style.backgroundColor = 'rgb(255, 133, 114)';
          btn.textContent = `SEARCH FOR “${query}”`;

          btn.addEventListener('click', e => {
            e.preventDefault();
            const encodedQuery = encodeURIComponent(query);
            window.location.href = `/search?q=${encodedQuery}&options%5Bprefix%5D=last`;
          });

          btnWrapper.appendChild(btn);
          container.appendChild(btnWrapper);

          const panel = document.querySelector('.aa-Panel');
          if (panel) {
            panel.parentNode.insertBefore(container, panel.nextSibling);
          }
        }

        input.addEventListener('input', () => {
          clearTimeout(debounceTimeout);
          const query = input.value.trim();
          if (!query) {
            removeDropdown();
            return;
          }
          debounceTimeout = setTimeout(() => {
            fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
              .then(r => r.json())
              .then(data => renderDropdown(query, data))
              .catch(() => removeDropdown());
          }, 300);
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
});
